import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage, withFormik, useFormik } from 'formik';
import { Effect } from 'formik-effect';
import * as yup from 'yup';
import Heading from '../heading/Heading';
import axios from "axios";
import * as UTIL from '../../util'; // Form Debugger
// import { Debug } from "./Debug";

import { Row, Col, Button } from 'react-bootstrap'; // Global Element

import { FormInput, FormCheckbox, Requirements } from './elements';
import Modal from "../modal/Modal";
import { Modal as BootstrapModal } from "react-bootstrap"; // Validation schema

import { validation } from './util/validation';

function Parent(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow() {
    return setShow(true);
  };

  var handleRedirect = function handleRedirect() {
    window.location = "/";
  };

  return /*#__PURE__*/React.createElement("div", null, children(show, handleShow, handleClose, handleRedirect));
}

var routeURL = "".concat(UTIL.apiUtil.API.emailNewsroom);
var formikEnhancer = withFormik({
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      firstName: props.firstName,
      lastName: props.lastName,
      emailAddress: props.emailAddress,
      phoneNumber: props.phoneNumber,
      mediaOutlet: props.mediaOutlet,
      role: props.role,
      array: props.setOnChange,
      allNews: false,
      emailSendTo: props.emailSendTo,
      checked: []
    };
  },
  validationSchema: yup.object().shape({
    firstName: validation.firstName,
    lastName: validation.lastName,
    emailAddress: validation.emailAddress,
    phoneNumber: validation.phoneNumber,
    mediaOutlet: validation.notEmpty
  }),
  handleSubmit: function handleSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    setTimeout(function () {
      JSON.stringify(values, null, 2);
      setSubmitting(false);
    }, 1000);
    axios({
      method: "post",
      url: routeURL,
      data: values
    }).then(function (response) {
      //handle success
      console.log(response);
    }).catch(function (response) {
      //handle error
      console.log(response);
    });
  },
  displayName: "NewsRoomForm" // helps with React DevTools

});

var NewsroomForm = function NewsroomForm(props) {
  var values = props.values,
      changeHandler = props.changeHandler,
      setFieldValue = props.setFieldValue,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      _props$emailSendTo = props.emailSendTo,
      emailSendTo = _props$emailSendTo === void 0 ? "emailSendTo" : _props$emailSendTo,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      errors = props.errors,
      checkboxes = props.checkboxes;
  useEffect(function () {
    if (!props.model) {
      setFieldValue(emailSendTo, "media.relations@crackerbarrel.com");
    } else {
      setFieldValue(emailSendTo, props.model.emailSendTo);
    }
  }, []);
  var ExperienceValidation = errors.firstName || errors.lastName || errors.userZipCode || errors.emailAddress || errors.phoneNumber || errors.termsAndConditions || errors.mediaOutlet;
  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, {
    className: "d-none"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    value: emailSendTo,
    name: "emailSendTo",
    label: "emailSendTo",
    component: FormInput,
    className: "cb-form__input--full"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: "Contact Information"
    },
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "mediaOutlet",
    label: "Media Outlet",
    component: FormInput
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "firstName",
    label: "First Name",
    component: FormInput
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "lastName",
    label: "Last Name",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "email",
    name: "emailAddress",
    label: "Email Address",
    component: FormInput
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "tel",
    name: "phoneNumber",
    label: "Phone Number",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    name: "role",
    label: "Role",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: {
      value: "What type of news are you interested in?"
    },
    className: "cb-type__title"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12"
  }, /*#__PURE__*/React.createElement(Field, {
    label: "Check All",
    type: "checkbox",
    name: "allNews",
    onChange: function onChange(e) {
      handleChange(e);

      if (!values.allNews) {
        setFieldValue("checked", []);
      }
    }
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: '5px',
      fontWeight: "bold"
    }
  }, "Check All")), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "checked",
    value: "Corporate Giving / Citizenship",
    checked: values.allNews || values.checked.includes("Corporate Giving / Citizenship")
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: '5px'
    }
  }, "Corporate Giving / Citizenship")), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "checked",
    value: "Corporate News",
    checked: values.allNews || values.checked.includes("Corporate News")
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: '5px'
    }
  }, "Corporate News")), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "checked",
    value: "Financial",
    checked: values.allNews || values.checked.includes("Financial")
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: '5px'
    }
  }, "Financial")), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "checked",
    value: "Food",
    checked: values.allNews || values.checked.includes("Food")
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: '5px'
    }
  }, "Food")), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "checked",
    value: "Music",
    checked: values.allNews || values.checked.includes("Music")
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: '5px'
    }
  }, "Music")), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "checked",
    value: "New Store Openings",
    checked: values.allNews || values.checked.includes("New Store Openings")
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: '5px'
    }
  }, "New Store Openings")), /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "checked",
    value: "Retail",
    checked: values.allNews || values.checked.includes("Retail")
  }), /*#__PURE__*/React.createElement("label", {
    style: {
      marginLeft: '5px'
    }
  }, "Retail"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Parent, null, function (show, handleShow, handleClose, handleRedirect) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: ExperienceValidation,
      onClick: function onClick(e) {
        return handleShow(true);
      },
      className: "cb-button-primary"
    }, "Submit"), /*#__PURE__*/React.createElement(Modal, {
      show: show,
      hide: handleClose,
      title: "THANK YOU"
    }, /*#__PURE__*/React.createElement(BootstrapModal.Body, {
      classname: "text-center"
    }, /*#__PURE__*/React.createElement("p", null, "Thank you for contacting Cracker Barrel. Your request has been forwarded to a Media Specialist.")), /*#__PURE__*/React.createElement(BootstrapModal.Footer, null, /*#__PURE__*/React.createElement(Button, {
      className: "cb-button-primary",
      onClick: handleRedirect
    }, "Return Home"))));
  }))));
};

export default formikEnhancer(NewsroomForm);